import { render, staticRenderFns } from "./QuoteTemplateListView.vue?vue&type=template&id=315ac614&scoped=true"
import script from "./QuoteTemplateListView.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateListView.vue?vue&type=script&lang=js"
import style0 from "./QuoteTemplateListView.vue?vue&type=style&index=0&id=315ac614&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315ac614",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315ac614')) {
      api.createRecord('315ac614', component.options)
    } else {
      api.reload('315ac614', component.options)
    }
    module.hot.accept("./QuoteTemplateListView.vue?vue&type=template&id=315ac614&scoped=true", function () {
      api.rerender('315ac614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quotetemplate/QuoteTemplateListView.vue"
export default component.exports